/* eslint no-console: 0 */
export default class SessionStorageHandler {
    static isCapable() {
        try {
            window.sessionStorage.setItem('capability', true);
            window.sessionStorage.getItem('capability');
            window.sessionStorage.removeItem('capability');
        } catch (e) {
            return false;
        }
        return true;
    }

    static setItem(key, value) {
        try {
            window.sessionStorage.setItem(key, value);
        } catch (e) {
            console.warn('Browser not capable of sessionStorage');
        }
    }

    static getItem(key) {
        try {
            return window.sessionStorage.getItem(key);
        } catch (e) {
            console.warn('Browser not capable of sessionStorage');
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/services/SessionStorageHandler.js